import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _, { isEmpty } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Label, TextField, ChoiceGroup, DefaultButton, PrimaryButton, Stack } from '@fluentui/react';

const getStyles = () => ({
  locationEditor: {
    '& .ms-Stack': {
      marginTop: '36px',
    },
    '& .ms-ChoiceFieldGroup': {
      marginBottom: '32px',
    },
  },
});

class UnstyledLocationEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      i18n, options,
    } = props;

    this.locationOptions = [
      { key: 'COUNTRY', text: i18n.getString(_TL_('Country/Region')) },
      { key: 'STATE', text: i18n.getString(_TL_('State/Province')) },
      { key: 'CITY', text: i18n.getString(_TL_('City')) },
    ];
    this.state = {
      defaultText: options.defaultText,
      locationFormat: this.getLocationFormat(options.locationFormat),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.options.defaultText !== prevProps.options.defaultText) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ defaultText: this.props.options.defaultText });
    }

    if (this.props.options.locationFormat !== prevProps.options.locationFormat) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ locationFormat: this.getLocationFormat(this.props.options.locationFormat) });
    }
  }

  onCancel = () => {
    this.props.updateAndCloseCallback(({ isCancel: true }));
  };

  onSave = () => {
    const {
      options, updateAndCloseCallback,
    } = this.props;
    const { defaultText, locationFormat } = this.state;

    const isDefaultTextEmpty = isEmpty(this.state.defaultText);
    const newValue = `${options.prefix}{LOCATION(${locationFormat})${isDefaultTextEmpty ? '' : `:${defaultText}`}}${options.suffix}`;
    const cursorPosition = newValue.length - options.suffix.length;
    updateAndCloseCallback({
      newValue,
      cursorPosition,
      isSelectedByUser: true,
    });
  };

  getLocationFormat(locationFormat) {
    return _.find(this.locationOptions, option => option.key === locationFormat.toUpperCase()) ? locationFormat.toUpperCase() : 'CITY';
  }

  render() {
    const {
      i18n, classes,
    } = this.props;

    return (
      <div className={classNames(classes.locationEditor, 'location-editor')} role="dialog">
        <Label htmlFor="location-format-radio-group">{i18n.getString(_TL_('Location Format'))}</Label>
        <ChoiceGroup
          id="location-format-radio-group"
          options={this.locationOptions}
          onChange={(event, option) => { this.setState({ locationFormat: option.key }); }}
          selectedKey={this.state.locationFormat}
        />
        <Label htmlFor="location-default-text-input">{i18n.getString(_TL_('Default text'))}</Label>
        <TextField
          id="location-default-text-input"
          value={this.state.defaultText}
          onChange={(event, value) => this.setState({ defaultText: value })}
        />
        <Stack horizontal gap={12}>
          <PrimaryButton className="btn-primary save" onClick={() => this.onSave()} >
            {i18n.getString(_TL_('Set'))}
          </PrimaryButton>
          <DefaultButton className="cancel" onClick={() => this.onCancel()} >
            {i18n.getString(_TL_('Cancel'))}
          </DefaultButton>
        </Stack>
      </div>);
  }
}

UnstyledLocationEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    locationEditor: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.shape({
    defaultText: PropTypes.string.isRequired,
    locationFormat: PropTypes.string.isRequired,
  }).isRequired,
  updateAndCloseCallback: PropTypes.func.isRequired,
};

const LocationEditor = withDefaultStyles(UnstyledLocationEditor, getStyles);
export default LocationEditor;
